/* eslint-disable */
export default {
    BASE_URL: 'https://esbo.release.easysend.pl',
    TOKEN_COOKIE_DOMAIN: '.release.easysend.pl',
    HOTJAR_ID: 1443585,
    HOTJAR_ID_BUSINESS: 1199186,
    GOOGLE_ANALYTICS_ID: null,
    //CHECKOUT_KEY_GB: 'pk_egizxuh22d5yzfxojy3oas3vxac',
    //CHECKOUT_KEY_SAS: 'pk_f3hx7qoxj4ou5ws56444jmxxqqv',
    CHECKOUT_KEY_GB: 'pk_sbox_i5bpsalw24b6qg3kqtfrqbvmx4j',
    CHECKOUT_KEY_SAS: 'pk_sbox_i5bpsalw24b6qg3kqtfrqbvmx4j',
    CLIENT_ID: '1_2xm0v2a12zy888osg880ogwsw4cocs80gw08w44s8cwc4g40w0',
    CLIENT_SECRET: '1b94t7z5zj34csogokgs8coo0og804cs8ko8wkowgc08oss488',
    PRODUCTION: false,
    PASSWORD_AUTOCOMPLETE_ENABLED: false,
    RAVEN: {
        DSN: 'https://7c10d37d92bd461dbd057c7f14218884@wtf.easysend.pl/18',
        PROJECT: '18',
        CONFIG: {
            ignoreErrors: [
                'top.GLOBALS',
                'originalCreateNotification',
                'canvas.contentDocument',
                'MyApp_RemoveAllHighlights',
                'http://tt.epicplay.com',
                'Can\'t find variable: ZiteReader',
                'jigsaw is not defined',
                'ComboSearch is not defined',
                'http://loading.retry.widdit.com/',
                'atomicFindClose',
                'fb_xd_fragment',
                'bmi_SafeAddOnload',
                'EBCallBackMessageReceived',
                'conduitPage',
                'Script error.'
            ],
            ignoreUrls: [
                /graph\.facebook\.com/i,
                /connect\.facebook\.net\/en_US\/all\.js/i,
                /eatdifferent\.com\.woopra-ns\.com/i,
                /static\.woopra\.com\/js\/woopra\.js/i,
                /extensions\//i,
                /^chrome:\/\//i,
                /127\.0\.0\.1:4001\/isrunning/i,
                /webappstoolbarba\.texthelp\.com\//i,
                /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
            ],
            whitelistUrls: [
                /app.release\.easysend\.pl/
            ],
            release: APP_VERSION //eslint-disable-line
        }
    },
    WEBSITE_URI: 'https://release.easysend.pl',
    FACEBOOK_APP_ID: '334116660112408',
    GOOGLE_APP_ID: '788269904969-43mr73ovdn6vu9vin55v63djh9kg953d.apps.googleusercontent.com',
    FACEBOOK_LOGIN_AVAILABLE: true,
    GOOGLE_LOGIN_AVAILABLE: true,
    APPLE_APP_ID: 'com.easysend.app-signin-test',
    APPLE_LOGIN_AVAILABLE: true,
    PUSHER: {
        APP_ID: 'ad9372c18f560599ecad',
        CLUSTER: 'eu'
    },
    NETVERIFY_REDIRECT_URL: 'https://easysend-test.lon.netverify.com/**',
    RECAPTCHA_CLIENT_PANEL_SITE_PUBLIC_KEY: '6LfB4oAdAAAAAOajtNIVIA8Gp6mCLAtKypV9PqRt',
    RECAPTCHA_ENABLE: true,
    FIREBASE: {
        apiKey: 'AIzaSyBRQZoMEMxG1JQECXsPFFEyz4C1LDZIbc4',
        authDomain: 'greg606test.firebaseapp.com',
        projectId: 'greg606test',
        storageBucket: 'greg606test.appspot.com',
        messagingSenderId: '1068188229143',
        appId: '1:1068188229143:web:21eaba7a40d9c722bdc652',
        measurementId: 'G-R85KQTNX1V'
    }
};




//////////////////
// WEBPACK FOOTER
// /home/app_release/www/shared/src/app/config/parameters.js
// module id = 184
// module chunks = 2